import { ArgumentNullException } from 'utility/exception/argument-null.exception';
import { IdValueObject } from 'utility/model/id-value-object.model';

export class BoardId extends IdValueObject {
  static create(value: string): BoardId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new BoardId(value);
  }
}
